<template>
  <div>
    <!-- header -->
    <SiteHeader />
    <!-- end header -->
    <!-- main banner -->
    <div>
      <div>
        <div class="hidden md:block">
          <div class="flex flex-wrap justify-center">
            <div class="w-1/2 py-20 bg-red-custom">
              <div class="m-auto lg:w-4/5">
                <div
                  class="px-4 text-4xl font-bold leading-tight text-center text-white lg:text-5xl"
                >
                  <h1>Looking For a Bed Bug Treatment That Works?</h1>
                </div>
                <div class="px-4 pt-4 text-lg leading-tight text-center text-white lg:text-xl">
                  <h2>
                    Our Pest Control Professionals are
                    <br />
                    <b>EXPERIENCE, TRAINED, ATTENTIVE, and RESPONSIBLE</b>
                  </h2>
                </div>
              </div>
            </div>
            <div
              class="w-1/2 bg-center bg-cover"
              style="background-image: url('/images/banner.jpg');"
            >
              <div
                class="hidden w-3/4 px-5 pt-4 m-auto my-8 font-bold text-center text-white lg:w-2/3 bg-red-custom"
              >
                <span class="text-lg">Same Day Call Back</span>
                <h3 class="text-4xl">Enquire Today!</h3>
                <iframe
                  allowtransparency="true"
                  width="100%"
                  id="contactform123"
                  name="contactform123"
                  marginwidth="0"
                  marginheight="0"
                  frameborder="0"
                  src="//feedback.activamedia.com.sg/my-contact-form-5408586.html"
                  style="min-height: 410px; height: inherit; overflow: auto;"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div class="block md:hidden">
          <div class="py-5 bg-pink-custom">
            <div class="m-auto sm:w-3/4">
              <div class="px-4 text-3xl font-bold leading-tight text-center text-white sm:text-4xl">
                <h1>Looking For a Bed Bug Treatment That Works?</h1>
              </div>
              <div class="px-4 pt-4 text-lg leading-tight text-center text-white">
                <h2>
                    Our Pest Control Professionals are
                    <br />
                    <b>EXPERIENCE, TRAINED, ATTENTIVE, and RESPONSIBLE</b>
                  </h2>
              </div>
            </div>
          </div>
          <div>
            <img src="/images/banner.jpg" alt="Background Images" />
          </div>
        </div>
      </div>
    </div>
    <!-- end main banner -->

    <!-- Thank you page -->
    <div class="py-8">
      <div class="container">
        <div>
          <h1
            class="text-2xl font-bold text-center lg:text-4xl color-custom"
          >Message Sending Successful!</h1>
        </div>
        <div class="py-3">
          <p
            class="text-lg text-center text-black"
          >Thank you for your kind interest in My Pest Pte Ltd. We will get back to you as soon as possible.</p>
        </div>
        <div>
          <!-- <router-link to="/">Go back to home</router-link> -->
          <router-link to="/">
            <div class="w-48 py-2 mx-auto text-center rounded-lg bg-red-custom">
              <h1 class="font-medium text-white">Back to Homepage</h1>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- end Thank you page -->

    <!-- footer -->
    <Copyright />
    <!-- end footer -->
  </div>
</template>

<script>
import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";
import Copyright from "@/components/Copyright.vue";

export default {
  components: {
    SiteHeader,
    SiteFooter,
    Copyright
  }
};
</script>

<style>
.bg-red-custom {
  background-color:#ce3243;
}
.color-custom {
  color: #ce3243;
}
</style>